import React, { FC, useCallback } from 'react';

import { Button } from '../../../button';
import { Modal } from '../../../modal/modal.component';
import { ModalIds } from '../../../../contexts/modals/modals.types';
import { Typography } from '../../../../../../../components';
import styles from './data-account-error-modal.module.scss';
import { useModalsContext } from '../../../../contexts';
import { useTranslation } from 'react-i18next';

/**
 * DataAccountError component
 * @description Content for the DataAccountError window
 *
 * @author Rostyslav Nahornyi, Oleksii Medvediev
 * @category Components
 */
const DataAccountError: FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'management' });
  const { dispatch } = useModalsContext();

  const closeModal = useCallback(() => {
    dispatch({ type: 'HIDE_MODAL', payload: ModalIds.dataAccountError });
  }, [dispatch]);

  return (
    <Modal modalId={ModalIds.dataAccountError} title={t('modals.settingsDataAccountError.title')}>
      <div className={styles.wrapper}>
        <Typography.Text variant={'bodyText5'}>{t('modals.settingsDataAccountError.description')}</Typography.Text>
        <Button size={'large'} variant={'main'} onClick={closeModal} className={styles.button}>
          <Typography.Text variant={'bodyText2'}>{t('modals.settingsDataAccountError.button')}</Typography.Text>
        </Button>
      </div>
    </Modal>
  );
};

export { DataAccountError };
